import { useEffect, useState } from "react";
import type { JSX } from "react";
import { clock } from "../lib/format";

/** Time since this client was let into the call, ticking once a second. */
export function CallClock({ since }: { readonly since: number }): JSX.Element {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  return (
    <span
      role="timer"
      aria-label="Time in call"
      style={{
        padding: "5px 10px",
        borderRadius: "var(--radius-sm)",
        background: "rgba(10,13,17,0.55)",
        color: "#fff",
        fontSize: 12,
        fontWeight: 600,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {clock((now - since) / 1000)}
    </span>
  );
}
